var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import * as DisplayMode from '../../constants/DisplayMode';
import { cssClassMap } from '../../constants/SportCssMap';
var messages = defineMessages({
    tab_content_tab_popular_sports: {
        id: 'tab_content.tab.popular_sports',
        defaultMessage: 'Топ-матчи'
    },
    tab_content_tab_line_popular_sports: {
        id: 'tab_content.tab.line_popular_sports',
        defaultMessage: 'Топ-матчи'
    },
    tab_content_tab_all_sports: {
        id: 'tab_content.tab.all_sports',
        defaultMessage: 'Все'
    },
    tab_content_tab_total_sports: {
        id: 'tab_content.tab.total_sports',
        defaultMessage: 'Тотал/37'
    },
    tab_content_tab_upcoming_events: {
        id: 'tab_content.tab.upcoming_events',
        defaultMessage: 'Предстоящие события'
    }
});
var RenderPreMatchSport = function (props) {
    var id = props.sport.get('id');
    var sportCssName = cssClassMap[id];
    var itemCls = props.pathname === "/sport/".concat(id) ? 'item selected' : 'item';
    var name = props.sport.get('name');
    if (props.eventSports.size > 0 && props.eventSports.first().get('id') === id && props.pathname.includes('/event/')) {
        itemCls = 'item selected';
    }
    return (_jsx("div", __assign({ className: itemCls }, { children: _jsxs("button", __assign({ onClick: function () { return props.preMatchSportClick(id); } }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), _jsx("p", __assign({ className: 'item-name' }, { children: name }))] })) })));
};
var RenderPopular = function (props) {
    var itemCls = props.pathname === "/sport" ? 'item selected' : 'item';
    var allFpIcon = props.darkTheme === true ? 'all-fp-dark.svg' : 'all-fp.svg';
    return (_jsx("div", __assign({ className: itemCls }, { children: _jsx(FormattedMessage, __assign({}, messages.tab_content_tab_line_popular_sports, { children: function (m) { return (_jsxs("button", __assign({ onClick: props.allMatchesClick }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(allFpIcon)), alt: '', style: {
                            objectFit: 'scale-down'
                        } }), _jsx("p", __assign({ className: 'item-name' }, { children: m }))] }))); } })) })));
};
var RenderLiveSport = function (props) {
    var id = props.sport.get('id');
    var sportCssName = cssClassMap[id];
    var name = props.sport.get('name');
    var itemCls = 'item';
    if (props.displayMode.type === DisplayMode.SPORT && props.displayMode.id === id) {
        itemCls = 'item selected';
    }
    return (_jsx("div", __assign({ className: itemCls }, { children: _jsxs("button", __assign({ onClick: function () { return props.liveSportClick(id); } }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), _jsx("p", __assign({ className: 'item-name' }, { children: name }))] })) })));
};
var RenderAll = function (props) {
    var itemCls = props.displayMode.type === DisplayMode.ALL ? 'item selected' : 'item';
    var allFpIcon = props.darkTheme === true ? 'all-fp-dark.svg' : 'all-fp.svg';
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ className: itemCls }, { children: _jsx(FormattedMessage, __assign({}, messages.tab_content_tab_all_sports, { children: function (m) { return (_jsxs("button", __assign({ onClick: props.topEventsClick }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(allFpIcon)), alt: '' }), _jsx("p", __assign({ className: 'item-name' }, { children: m }))] }))); } })) })) }));
};
var RenderTimetable = function (props) {
    var calendarCls = props.pathname === "/timetable" ? 'item selected' : 'item';
    return (_jsx("div", __assign({ className: "item calendar-svg ".concat(calendarCls) }, { children: _jsx(FormattedMessage, __assign({}, messages.tab_content_tab_upcoming_events, { children: function (m) { return (_jsxs("button", __assign({ onClick: function () { return props.preMatchSportClick("/timetable"); }, className: 'ajax calendar-show' }, { children: [_jsx("img", { src: require("../../assets/img/icons/calendar.svg"), alt: '' }), _jsx("p", __assign({ className: 'item-name' }, { children: m }))] }))); } })) })));
};
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Carousel.prototype.render = function () {
        var _a = this.props, auth = _a.auth, pathname = _a.pathname, sports = _a.sports, activeTab = _a.activeTab, preMatchSportClick = _a.preMatchSportClick, fetching = _a.fetching, liveSportClick = _a.liveSportClick, displayMode = _a.displayMode, selectedSportId = _a.selectedSportId, topEventsClick = _a.topEventsClick, allMatchesClick = _a.allMatchesClick, eventSports = _a.eventSports;
        var renderItems = [];
        sports.map(function (sport, i) {
            var props = { sport: sport, pathname: pathname };
            if (pathname !== '/live' && pathname !== '/timetable' && activeTab === 'sport') {
                renderItems.push(_jsx(RenderPreMatchSport, __assign({}, props, { preMatchSportClick: preMatchSportClick, selectedSportId: selectedSportId, eventSports: eventSports }), i));
            }
            else {
                renderItems.push(_jsx(RenderLiveSport, __assign({}, props, { displayMode: displayMode, liveSportClick: liveSportClick }), i));
            }
        });
        if ((activeTab === 'live') && sports.size > 0) {
            renderItems.push(_jsx(RenderTimetable, { pathname: pathname, preMatchSportClick: preMatchSportClick }, 'timetable'));
        }
        var renderAll = activeTab === 'sport' ?
            _jsx(RenderPopular, { pathname: pathname, allMatchesClick: allMatchesClick, darkTheme: this.props.darkTheme }) :
            _jsx(RenderAll, { displayMode: displayMode, topEventsClick: topEventsClick, auth: auth, countryCode: this.props.countryCode, darkTheme: this.props.darkTheme });
        return (_jsxs("div", __assign({ className: classNames("carousel", { fetching: fetching }) }, { children: [_jsx("div", { className: 'please_wait', style: { width: '100%' } }), sports.size > 0 && renderAll, renderItems] })));
    };
    return Carousel;
}(React.Component));
Carousel.propTypes = {
    auth: PropTypes.object.isRequired,
    eventSports: PropTypes.object.isRequired,
    preMatchSportClick: PropTypes.func.isRequired,
    liveSportClick: PropTypes.func.isRequired,
    topEventsClick: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    activeTab: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    sports: PropTypes.object.isRequired,
    displayMode: PropTypes.object.isRequired,
    darkTheme: PropTypes.bool.isRequired,
};
var mapStateToProps = function (state) {
    return {
        auth: state.auth,
        darkTheme: state.application.get('darkTheme'),
        eventSports: state.application.getIn(['preMatchEvent', 'sports'])
    };
};
export default connect(mapStateToProps, null)(withRouter(Carousel));



// WEBPACK FOOTER //
// ./src/components/menu/Carousel.jsx